<template>
    <div id="order-page" :style="{minHeight: bodyHeight}">
        <div class="no-booking" v-show="noBook">
            <div class="book-text">
                <h2>您还没有预约过优品</h2>
                <h3>“咦，这里空空的，还是去别处看看吧～”</h3>
                <h1>为您推荐</h1>
            </div>
            <Recommend :ProductList="ProductList"></Recommend>
        </div>
        <Product v-for="(item, idx) in OrderList"
                 :key="idx"
                 :status="item.status"
                 :shopId="item.shop"
                 :commonImg = "item.commonImg"
                 :commonName="item.commonName"
                 :commonNo="item.commonNo"
                 :sellPrice="item.sellPrice"
                 :price="item.price"
                 :qrCodeUrl="item.qrCodeUrl"
                 :shopLogo="item.shopLogo"
                 :floorName="item.floorName"
                 :startTime="item.startTime"
                 :endTime="item.endTime"
                 :shopBunk = "item.shopBunk"
                 :shopName="item.shopName" />
        <div v-show="!noBook" class="loading-done">
          没有更多了
        </div>
    </div>
</template>
<script>
    import {Util} from '../commons/util'
    import Product from '@/components/commons/Product'
    import Recommend from '@/components/commons/recommend'
    import Server from '../services/Entrance';

    export default {
        name: 'Order',
        data () {
            return {
                bodyHeight: '',
                noBook: false,
                OrderList: [],
                ProductList: []
            }
        },
        // 生命周期钩子
        mounted () {

            this.bodyHeight = window.screen.height + 'px';
            document.title = '我的预约';
            if ($.isApp) {
                $.AppReady().done(function (Bridge) {
                    if ($.os.ios && typeof Bridge.documentNavStyle === "function") {
                        Bridge.documentNavStyle();
                    } else if ($.os.android) {
                        Bridge.setText({
                            titleText: '商品详情'
                        });
                    }
                })
            }
        },
        components: {
            Product,
            Recommend
        },
        beforeRouteEnter(to, from, next) {

            let urlParams = to.params;

            Util.auth(()=>{
                Server.order.queryOrderList(urlParams.storeCode).then(data => {

                    return data;
                }).then(data => {
                    next(vm => {

                        if (data.length == 0) {

                            vm.noBook = true;

                            Server.order.commonDetail(urlParams.storeCode).then(d => {

                                for (let i = 0, len = d.length; i < len; i++) {
                                    vm.ProductList.push({
                                        id: 'scroll-' + i,
                                        width: '0',
                                        shop: d[i].shop,
                                        shopLogo: d[i].shopLogo,
                                        shopName: d[i].shopName,
                                        floorName: d[i].floorName,
                                        categoryName: d[i].categoryName,
                                        floor: d[i].floor,
                                        listPro: d[i].commonList || []
                                    })
                                }
                            });
                        } else {
                            vm.OrderList = data;
                        }
                    });
                });
            })
        },
        methods: {
        }
    }
</script>
<style scoped>
#order-page {
    background: #f2f2f2;

    .order-list {
        margin-bottom: 10px;
    }
}
.no-booking {
    overflow: hidden;
    background: #f1f1f0;

    &:before {
        margin: 111px auto 41px auto;
        display: block;
        content: '';
        width: 256px;
        height: 297px;
        background: url("../assets/book-none.png") 50% 50% no-repeat;
        background-size: 256px 297px;
    }

    .book-text {
        text-align: center;
        font-size: 36px;
        color: #323232;
        font-weight: bold;

        h3 {
            font-size: 28px;
            margin-top: 10px;
            margin-bottom: 44px;
        }

        h1 {
            position: relative;

            &:before,&:after {
                content: '';
                display: block;
                width: 242px;
                height: 1px;
                border-top: 1px solid #000;
                position: absolute;
                top: 50%;
            }

            &:before {
                left: 38px;
            }

            &:after {
                right: 38px;
            }

        }
    }
}
.loading-done {
    font-size:24px;
    color:#999999;
    width: 100%;
    text-align: center;
    display: block;
    padding: 40px 0;
    position: relative;

    &:before, &:after {
        content: '';
        display: block;
        width: 170px;
        height: 1px;
        position: absolute;
        top: 50%;
        border-top: 1px solid #999;
    }

    &:before {
         right: 500px;
    }
    &:after {
         left: 500px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue